import { createContext } from 'react';
import type { UserContract } from '@raas/shared/src/features/user/contracts/user.type';

export interface UserDataContextContract {
  user: UserContract | null;
  isLoading: boolean;
  setUser: (user: UserContract | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  interfaceType: 'INTERNAL_ACCESS' | 'EXTERNAL_ACCESS';
}

const UserDataContext = createContext<UserDataContextContract | undefined>(undefined);

export default UserDataContext;
